import React, { useEffect } from 'react'
import { useContext, useState } from 'react'
import cross from '../../../../assets/orders/cross.svg'
import ModalContext from '../../../../contexts/ModalContext'
import SectionContext from '../../../../contexts/SectionContext'
import plus from '../../../../assets/headers/plus.svg'
import save from '../../../../assets/router/save.svg'
import axios from '../../../../config/axios'
import { mock } from './utils'
import {
  Container,
  HeaderDiv,
  HeaderText,
  CloseDiv,
  CloseImg,
  InputDiv,
  InputLabel,
  StyledSelect,
  StyledOption,
  LineDiv,
  StyledDate,
  Input,
  GridContainer,
  ButtonOfSection,
  ButtonOfSectionText,
  PlusImg,
  OptionsDiv,
  SelectContainer,
  SelectData,
  CompanyAddressSelect,
  ConformityStatus,
  CenterItensContainer,
} from './style'
import { FreightContext } from '../../../../contexts/FreightContext'
import { ButtonImage } from '../../../Orders/DetailsModal/style'
import { set } from 'date-fns'
import { de } from 'date-fns/locale'
import { read } from 'xlsx'
import { ButtonCreate } from '../../style'
import { FeedbackContext } from '../../../../contexts/FeedbackContext'
import { useNavigate } from 'react-router-dom'
import ModalTest from '../../../BaseModal'
import { Check, Info } from 'lucide-react'
import SelectCustomerInFreight from './searchClient'
import ApiService from '../../../../services/ApiService'

type CompanyAddressShape = {
  id?: number
  cep: string
  state: { id: number; name: string }
  city: { id: number; name: string }
  neighborhood: { id: number; name: string }
  street: string
  number: string
  complement: string
}

type CompanyAddressOption = {
  key: string
  label: string
  address: CompanyAddressShape
}

const formatCepDisplay = (cep: string) => {
  const digits = String(cep || '').replace(/\D/g, '')
  if (digits.length !== 8) return cep || ''
  return `${digits.slice(0, 5)}-${digits.slice(5)}`
}

const hasValidCompanyAddress = (addr?: Partial<CompanyAddressShape> | null) => {
  if (!addr) return false
  return !!(
    String(addr.cep || '').trim() ||
    String(addr.street || '').trim() ||
    String(addr.neighborhood?.name || '').trim() ||
    String(addr.city?.name || '').trim() ||
    String(addr.state?.name || '').trim()
  )
}

const formatAddressSummary = (addr: CompanyAddressShape) => {
  const parts: string[] = []
  if (addr.street) parts.push(addr.street)
  if (addr.number) parts.push(`nº ${addr.number}`)
  const location = [addr.neighborhood?.name, addr.city?.name, addr.state?.name]
    .filter(Boolean)
    .join(', ')
  if (location) parts.push(location)
  if (addr.cep) parts.push(formatCepDisplay(addr.cep))
  return parts.join(' — ') || 'Endereço sem detalhes'
}

const buildCompanyAddressOptions = (company: any): CompanyAddressOption[] => {
  const options: CompanyAddressOption[] = []

  const billing: CompanyAddressShape = {
    cep: company.cep || '',
    state: company.state || { id: 0, name: '' },
    city: company.city || { id: 0, name: '' },
    neighborhood: company.neighborhood || { id: 0, name: '' },
    street: company.street || '',
    number: company.number || '',
    complement: company.complement || '',
  }

  if (hasValidCompanyAddress(billing)) {
    options.push({
      key: 'billing',
      label: `Faturamento — ${formatAddressSummary(billing)}`,
      address: billing,
    })
  }

  ;(company.deliveryAddresses || []).forEach((addr: CompanyAddressShape, index: number) => {
    if (!hasValidCompanyAddress(addr)) return
    options.push({
      key: `delivery-${addr.id ?? index}`,
      label: `Entrega — ${formatAddressSummary(addr)}`,
      address: addr,
    })
  })

  return options
}

const FreightForm = () => {

  const formatToDateInput = (dateString: string): string => {
    if (!dateString || dateString.length < 10) return ''
    const [day, month, year] = dateString.split('/')
    return `${year}-${month}-${day}`
  }

  const formatFromDateInput = (dateString: string): string => {
    if (!dateString || dateString.length < 10) return ''


    const dateRegex = /^\d{4}-\d{2}-\d{2}$/
    if (!dateRegex.test(dateString)) return ''

    const [year, month, day] = dateString.split('-')


    if (year.length !== 4) return ''

    return `${day}/${month}/${year}`
  }

  const handleDateChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    type: 'deadLine' | 'readyToShip',
  ) => {
    const value = e.target.value


    if (value.length > 10) {
      e.target.value = value.slice(0, 10)
      return
    }


    if (value.length === 10) {
      const year = value.split('-')[0]
      if (year.length > 4) {
        e.target.value = value.slice(0, 6) + value.slice(7)
        return
      }
    }

    if (type === 'deadLine') {
      handleDeadlineChange(value)
    } else {
      handleReadyToShipChange(value)
    }
  }

  const dataFormatter = (isoDateString: string): string => {
    if (!isoDateString) {
      return ''
    }

    const dateUtc = new Date(isoDateString)

    if (isNaN(dateUtc.getTime())) {
      console.error('Data ISO inválida recebida:', isoDateString)
      return ''
    }

    const year = dateUtc.getUTCFullYear()
    const month = dateUtc.getUTCMonth() + 1
    const day = dateUtc.getUTCDate()

    const formattedMonth = month < 10 ? `0${month}` : month
    const formattedDay = day < 10 ? `0${day}` : day

    return `${formattedDay}/${formattedMonth}/${year}`
  }

  const { setModalActive, setModalSection } = useContext(ModalContext)
  const { routerSection, setRouterSection } = useContext(SectionContext)
  const [value, setValue] = useState('Selecione')
  const [selectedClient, setSelectedClient] = useState<string | null>(null)
  const [selectedType, setSelectedType] = useState<string | null>(null)
  const [street, setStreet] = useState<string | null>(null)
  const [neighborhood, setNeighborhood] = useState<string | null>(null)
  const [city, setCity] = useState<string | null>(null)
  const [uf, setUf] = useState<string | null>(null)
  const [number, setNumber] = useState<number | null>(null)
  const [autoAddress, setAutoAddress] = useState({
    street: false,
    neighborhood: false,
    city: false,
    state: false,
  })
  const clients: string[] = ['Luis', 'João', 'Richard']
  const types: string[] = ['Entrega', 'Retirada', 'Sem endereço']
  const { freight, setFreight } = useContext(FreightContext)
  const [cep, setCep] = useState(freight?.Address?.cep || '')
  const lastSearchedCep = React.useRef<string>('')
  const isInitialLoadCep = React.useRef<boolean>(true)
  const initialCep = React.useRef<string>(
    freight?.Address?.cep !== undefined && freight?.Address?.cep !== null
      ? String(freight?.Address?.cep)
      : '',
  )
  const { setFeedback } = useContext(FeedbackContext)
  const [companies, setCompanies] = useState<any[]>([])
  const [observation, setObservation] = useState<string>(
    freight?.observation || '',
  )
  const [orderNumber, setOrderNumber] = useState<string>(
    freight?.orderNumber || '',
  )
  const [duplicateBlocker, setDuplicateBlocker] = useState<boolean>(false)
  const [company, setCompany] = useState<{ id: number; companyName: string }>({
    id: freight?.Company?.id || 0,
    companyName: freight?.Company?.companyName || '',
  })
  const [companyAddressOptions, setCompanyAddressOptions] = useState<CompanyAddressOption[]>([])
  const [selectedCompanyAddressKey, setSelectedCompanyAddressKey] = useState('')
  const navigate = useNavigate()
  const [addressPostBody, setAddressPostBody] = useState({
    cep: freight?.Address?.cep || '',
    street: freight?.Address?.street || '',
    number: freight?.Address?.number || '',
    complement: freight?.Address?.complement || '',
    neighborhood: {
      name: freight?.Address?.Neighborhood?.name || '',
      id: freight?.Address?.Neighborhood?.id || 0,
    },
    city: {
      name: freight?.Address?.Neighborhood?.City?.name || '',
      id: freight?.Address?.Neighborhood?.City?.id || 0,
    },
    state: {
      name: freight?.Address?.Neighborhood?.City?.State?.name || '',
      id: freight?.Address?.Neighborhood?.City?.State?.id || 0,
    },
  })
  const [addressPutBody, setAddressPutBody] = useState({
    id: freight?.Address?.id,
    cep: freight?.Address?.cep || '',
    street: freight?.Address?.street || '',
    number: freight?.Address?.number || '',
    complement: freight?.Address?.complement || '',
    neighborhood: {
      name: freight?.Address?.Neighborhood?.name || '',
      id: freight?.Address?.Neighborhood?.id || 0,
    },
    city: {
      name: freight?.Address?.Neighborhood?.City?.name || '',
      id: freight?.Address?.Neighborhood?.City?.id || 0,
    },
    state: {
      name: freight?.Address?.Neighborhood?.City?.State?.name || '',
      id: freight?.Address?.Neighborhood?.City?.State?.id || 0,
    },
  })
  const [formData, setFormData] = useState({
    type: freight?.type || 'Entrega',
    detail: freight?.detail || '',
    observastion: freight?.observation || '',
    deadLine: freight?.deadLine ? dataFormatter(freight.deadLine) : '',
    readyToShip: freight?.readyToShip ? dataFormatter(freight.readyToShip) : '',
    address: {
      street: freight?.Address?.street || '',
      number: freight?.Address?.number || '',
      complement: freight?.Address?.complement || '',
      cep: freight?.Address?.cep || '',
      neighborhood: {
        name: freight?.Address?.Neighborhood?.name || '',
        city: {
          name: freight?.Address?.Neighborhood?.City?.name || '',
          state: {
            name: freight?.Address?.Neighborhood?.City?.State?.name || '',
          },
        },
      },
    },
    load: {
      height: freight?.Load?.height || 0,
      width: freight?.Load?.width || 0,
      length: freight?.Load?.length || 0,
      cubage: freight?.Load?.cubage || 0,
      weight: freight?.Load?.weight || 0,
      detail: freight?.Load?.detail || '',
    },
  })

  const getCompanies = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_GATEWAY_BASE_URL}/companies/companies`,
      { params: { filters: ['1', '2'] } },
    )
    setCompanies(response.data)
  }

  const handleDeadlineChange = (date: string) => {
    const formatted = formatFromDateInput(date)
    setFormData((prev) => ({
      ...prev,
      deadLine: formatted,
    }))
  }

  const handleReadyToShipChange = (date: string) => {
    const formatted = formatFromDateInput(date)
    setFormData((prev) => ({
      ...prev,
      readyToShip: formatted,
    }))
  }

  const setNestedField = (obj: any, path: string, value: any) => {
    const keys = path.split('.')
    const updated = { ...obj }
    let current: any = updated

    keys.slice(0, -1).forEach((key) => {
      if (!current[key]) current[key] = {}
      current = current[key] as Record<string, any>
    })

    current[keys[keys.length - 1]] = value

    if (path.includes('neighborhood')) {
      console.log('DEBUG [FREIGHT FORM] setNestedField neighborhood update', {
        path,
        value,
        updated,
      })
    }

    return updated
  }

  const handleDataChange = (path: string, value: any) => {
    setFormData((prev) => {
      const keys = path.split('.')
      const updated = { ...prev }
      let current: any = updated

      keys.slice(0, -1).forEach((key) => {
        if (!current[key]) current[key] = {}
        current = current[key] as Record<string, any>
      })

      current[keys[keys.length - 1]] = value
      return updated
    })

    if (path.startsWith('address.')) {
      const addressPath = path.replace(/^address\./, '')

      const shouldClearNeighborhoodId = addressPath === 'neighborhood.name'

      if (freight) {
        setAddressPutBody((prev) => {
          const updated = setNestedField(prev, addressPath, value)
          if (shouldClearNeighborhoodId) {
            updated.neighborhood = { ...updated.neighborhood, id: 0 }
            console.log('DEBUG [FREIGHT FORM] clearing neighborhood.id because name was manually edited', updated.neighborhood)
          }
          return updated
        })
      } else {
        setAddressPostBody((prev) => {
          const updated = setNestedField(prev, addressPath, value)
          if (shouldClearNeighborhoodId) {
            updated.neighborhood = { ...updated.neighborhood, id: 0 }
            console.log('DEBUG [FREIGHT FORM] clearing neighborhood.id because name was manually edited', updated.neighborhood)
          }
          return updated
        })
      }
    }
  }

  useEffect(() => {
    console.debug('DEBUG [FREIGHT FORM] formData.address changed', formData.address)
  }, [formData.address])

  useEffect(() => {
    if (freight?.Address?.cep) {
      setNumber(Number(freight?.Address?.number))
      setSelectedClient(freight?.Company?.companyName || '')
      setFormData((prevData) => ({
        ...prevData,
        deadLine: freight?.deadLine ? dataFormatter(freight.deadLine) : '',
        readyToShip: freight?.readyToShip
          ? dataFormatter(freight.deadLine)
          : '',
        address: {
          ...prevData.address,
          cep:
            String(freight.Address.cep)
              .padStart(8, '0')
              .slice(0, 5) +
            '-' +
            String(freight.Address.cep).padStart(8, '0').slice(5),
          street: freight.Address.street,
          neighborhood: {
            name: freight.Address.Neighborhood.name,
            city: {
              name: freight.Address.Neighborhood.City.name,
              state: {
                name: freight.Address.Neighborhood.City.State.name,
                uf: freight.Address.Neighborhood.City.State.uf,
              },
            },
          },
          number: freight?.Address?.number,
          complement: freight?.Address?.complement,
        },
        load: {
          ...prevData.load,
          height: freight.Load?.height || 0,
          width: freight.Load?.width || 0,
          weight: freight.Load?.weight || 0,
          length: freight?.Load?.length || 0,
          cubage: freight?.Load?.cubage || 0,
          detail: freight?.Load?.detail || '',
        },
      }))
    }
  }, [freight])

  const handleClick = () => {
    setModalSection('router')
    setModalActive(true)
  }

  const dataFormatterISO = (dateString: string): string => {

    const parts = dateString.split('/')
    if (parts.length !== 3) {
      console.error(
        "Formato de data inválido. Esperado 'dd/mm/yyyy'. Recebido:",
        dateString,
      )

      return ''
    }

    const [day, month, year] = parts

    const dateObject = new Date(
      Date.UTC(parseInt(year), parseInt(month) - 1, parseInt(day)),
    )

    if (
      dateObject.getUTCFullYear() !== parseInt(year) ||
      dateObject.getUTCMonth() !== parseInt(month) - 1 ||
      dateObject.getUTCDate() !== parseInt(day)
    ) {
      console.error("A data original ('" + dateString + "') é inválida.")
      return ''
    }

    return dateObject.toISOString()
  }

  const close = () => {
    navigate('..')
  }

  const buildAddressPayloadForSubmit = () => {
    const cepDigits = String(formData.address.cep || addressPostBody.cep || '').replace(/\D/g, '')

    return {
      cep: cepDigits,
      street: formData.address.street || addressPostBody.street || '',
      number: formData.address.number || addressPostBody.number || '',
      complement: formData.address.complement || addressPostBody.complement || '',
      neighborhood: {
        id: addressPostBody.neighborhood?.id || 0,
        name: formData.address.neighborhood?.name || addressPostBody.neighborhood?.name || '',
      },
      city: {
        id: addressPostBody.city?.id || 0,
        name: formData.address.neighborhood?.city?.name || addressPostBody.city?.name || '',
      },
      state: {
        id: addressPostBody.state?.id || 0,
        name: formData.address.neighborhood?.city?.state?.name || addressPostBody.state?.name || '',
      },
    }
  }

  const postFreight = async () => {
    setDuplicateBlocker(true)
    try {
      const token = localStorage.getItem('token')

      const deadLineISO = dataFormatterISO(formData.deadLine)
      if (!deadLineISO) {
        setFeedback({
          isOpen: true,
          message: 'Data limite inválida. Use o formato dd/mm/aaaa.',
          statusOk: false,
        })
        setDuplicateBlocker(false)
        return
      }

      if (!selectedType) {
        setFeedback({
          isOpen: true,
          message: 'Tipo de frete é obrigatório.',
          statusOk: false,
        })
        setDuplicateBlocker(false)
        return
      }

      const readyToShipISO = formData.readyToShip
        ? dataFormatterISO(formData.readyToShip)
        : undefined

      let address: any | undefined
      if (selectedType !== 'Sem endereço') {
        address = buildAddressPayloadForSubmit()
      }

      const loadData = {
        height: Number(formData.load.height) || 0,
        width: Number(formData.load.width) || 0,
        length: Number(formData.load.length) || 0,
        cubage: Number(formData.load.cubage) || 0,
        weight: Number(formData.load.weight) || 0,
        detail: formData.load.detail,
      }

      const body: any = {
        type: selectedType || freight?.type,
        detail: formData.detail,
        observation: observation,
        orderNumber: orderNumber,
        deadLine: deadLineISO,
        readyToShip: readyToShipISO,
        companyId: company.id || freight?.companyId,
        routeId: null,
        Load: loadData,
      }

      if (address) {
        body.Address = address
      }

      console.log('DEBUG [FREIGHT FORM] request payload:', {
        addressPayload: address,
        body,
        addressPostBody,
        addressPutBody,
      })

      if (!freight) {
        const response = await axios.post(
          `${process.env.REACT_APP_GATEWAY_BASE_URL}/router/freight`,
          body,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          },
        )
        if (response.data) {
          setFeedback({
            isOpen: true,
            message: 'Frete cadastrado com sucesso!',
            statusOk: true,
          })
          setDuplicateBlocker(false)
          close()
        }
      }
    } catch (error: any) {
      console.error('❌ [FRETE-FORM] Erro ao criar frete:', error?.response?.data || error)
      setFeedback({
        isOpen: true,
        message: error?.response?.data?.message || 'Erro ao criar frete',
        statusOk: false,
      })
      setDuplicateBlocker(false)
    }
  }

  const putFreight = async () => {
    setDuplicateBlocker(true)
    try {
      const deadLineISO = dataFormatterISO(formData.deadLine)
      if (!deadLineISO) {
        setFeedback({
          isOpen: true,
          message: 'Data limite inválida. Use o formato dd/mm/aaaa.',
          statusOk: false,
        })
        setDuplicateBlocker(false)
        return
      }

      if (!selectedType) {
        setFeedback({
          isOpen: true,
          message: 'Tipo de frete é obrigatório.',
          statusOk: false,
        })
        setDuplicateBlocker(false)
        return
      }

      const readyToShipISO = formData.readyToShip
        ? dataFormatterISO(formData.readyToShip)
        : undefined

      const addressToSend: any | undefined =
        selectedType !== 'Sem endereço'
          ? {
            ...addressPutBody,
            cep: formData.address.cep,
            street: formData.address.street,
            number: formData.address.number,
            complement: formData.address.complement,
            neighborhood: {
              ...addressPutBody.neighborhood,
              name: formData.address.neighborhood.name,
              id: addressPutBody.neighborhood?.id || 0,
            },
            city: {
              ...addressPutBody.city,
              name: formData.address.neighborhood.city.name,
              id: addressPutBody.city?.id || 0,
            },
            state: {
              ...addressPutBody.state,
              name: formData.address.neighborhood.city.state.name,
              id: addressPutBody.state?.id || 0,
            },

            Neighborhood: {
              ...addressPutBody.neighborhood,
              name: formData.address.neighborhood.name,
              id: addressPutBody.neighborhood?.id || 0,
            },
            City: {
              ...addressPutBody.city,
              name: formData.address.neighborhood.city.name,
              id: addressPutBody.city?.id || 0,
            },
            State: {
              ...addressPutBody.state,
              name: formData.address.neighborhood.city.state.name,
              id: addressPutBody.state?.id || 0,
            },
          }
          : undefined

      const loadData = {
        height: Number(formData.load.height) || 0,
        width: Number(formData.load.width) || 0,
        length: Number(formData.load.length) || 0,
        cubage: Number(formData.load.cubage) || 0,
        weight: Number(formData.load.weight) || 0,
        detail: formData.load.detail,
      }

      const body: any = {
        type: selectedType || freight?.type,
        detail: formData.detail,
        observation: observation,
        orderNumber: orderNumber,
        deadLine: deadLineISO,
        companyId: company.id || freight?.companyId,
        routeId: freight?.routeId,
        readyToShip: readyToShipISO,
        Load: loadData,
      }

      if (addressToSend) {
        body.Address = addressToSend
      } else {
        body.Address = addressPutBody
      }

      console.log('DEBUG [FREIGHT FORM] PUT payload (raw)', {
        body,
        addressPostBody,
        addressPutBody,
      })
      console.debug('DEBUG [FREIGHT FORM] PUT payload (stringified)', JSON.stringify({
        body,
        addressPostBody,
        addressPutBody,
      }))

      const response = await axios.put(
        `${process.env.REACT_APP_GATEWAY_BASE_URL}/router/freight/${freight?.id}`,
        body,
      )
      if (response.data) {
        setFeedback({
          isOpen: true,
          message: 'Frete atualizado!',
          statusOk: true,
        })
        setDuplicateBlocker(false)
        close()
      }
    } catch (error: any) {
      console.error('❌ [FRETE-FORM] Erro ao atualizar frete:', error?.response?.data || error)
      setFeedback({
        isOpen: true,
        message: error?.response?.data?.message || 'Erro ao criar frete',
        statusOk: false,
      })
      setDuplicateBlocker(false)
    }
  }

  const getCep = async (cep: string) => {
    const digits = cep.replace(/\D/g, '')

    let formatted = ''

    if (digits.length > 0) {
      formatted += digits.substring(0, Math.min(5, digits.length))

      if (digits.length > 5) {
        formatted += '-' + digits.substring(5, Math.min(8, digits.length))
      }
    }

    setFormData((prevData) => ({
      ...prevData,
      address: {
        ...prevData.address,
        cep: formatted,
      },
    }))

    if (digits.length === 0) {
      setAddressPutBody((prevData) => ({
        ...prevData,
        cep: '',
        street: '',
        city: { name: '', id: 0 },
        neighborhood: { name: '', id: 0 },
        state: { name: '', id: 0 },
        number: '',
        complement: '',
      }))
      setAddressPostBody((prevData) => ({
        ...prevData,
        cep: '',
        street: '',
        city: { name: '', id: 0 },
        neighborhood: { name: '', id: 0 },
        state: { name: '', id: 0 },
        number: '',
        complement: '',
      }))
      setFormData((prevData) => ({
        ...prevData,
        address: {
          ...prevData.address,
          street: '',
          neighborhood: { name: '', city: { name: '', state: { name: '' } } },
          city: { name: '', state: { name: '' } },
          state: { name: '' },
          number: '',
          complement: '',
        },
      }))
      lastSearchedCep.current = ''
      isInitialLoadCep.current = false
      return
    }

    if (digits.length !== 8) {
      return
    }

    if (isInitialLoadCep.current) {
      isInitialLoadCep.current = false

      const initialDigits = initialCep.current.replace(/\D/g, '')
      if (initialDigits.length === 8 && initialDigits === digits) {
        lastSearchedCep.current = digits
        return
      }
    }

    if (digits === lastSearchedCep.current) {
      return
    }

    setAddressPutBody((prevData) => ({
      ...prevData,
      street: '',
      city: { name: '', id: 0 },
      neighborhood: { name: '', id: 0 },
      state: { name: '', id: 0 },
      number: '',
      complement: '',
    }))
    setAddressPostBody((prevData) => ({
      ...prevData,
      street: '',
      city: { name: '', id: 0 },
      neighborhood: { name: '', id: 0 },
      state: { name: '', id: 0 },
      number: '',
      complement: '',
    }))
    setFormData((prevData) => ({
      ...prevData,
      address: {
        ...prevData.address,
        street: '',
        neighborhood: { name: '', city: { name: '', state: { name: '' } } },
        city: { name: '', state: { name: '' } },
        state: { name: '' },
        number: '',
        complement: '',
      },
    }))
    setAutoAddress({ street: false, neighborhood: false, city: false, state: false })

    lastSearchedCep.current = digits

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_GATEWAY_BASE_URL}/companies/address/cep`,
        { cep },
      )
      const data = response.data

      const street = data.street || ''
      const neighborhoodName = data.neighborhood?.name || ''
      const cityName = data.city?.name || ''
      const stateName = data.state?.name || ''

      console.debug('DEBUG [FREIGHT FORM] CEP lookup result', {
        cep: digits,
        street,
        neighborhoodName,
        cityName,
        stateName,
        raw: data,
      })

      setAutoAddress({
        street: !!street,
        neighborhood: !!neighborhoodName,
        city: !!cityName,
        state: !!stateName,
      })

      if (freight) {
        setAddressPutBody((prevData) => ({
          ...prevData,
          cep: cep.replace(/\D/g, ''),
          street,
          city: {
            name: cityName,
            id: data.city?.id || 0,
          },
          neighborhood: {
            name: neighborhoodName,
            id: data.neighborhood?.id || 0,
          },
          state: {
            name: stateName,
            id: data.state?.id || 0,
          },
        }))
      } else {
        setAddressPostBody((prevData) => ({
          ...prevData,
          cep: cep.replace(/\D/g, ''),
          street,
          city: {
            name: cityName,
            id: data.city?.id || 0,
          },
          neighborhood: {
            name: neighborhoodName,
            id: data.neighborhood?.id || 0,
          },
          state: {
            name: stateName,
            id: data.state?.id || 0,
          },
        }))
      }

      setFormData((prevData) => {
        const next = {
          ...prevData,
          address: {
            ...prevData.address,
            cep: formatted,
            street,
            neighborhood: {
              name: neighborhoodName,
              city: {
                name: cityName,
                state: {
                  name: stateName,
                },
              },
            },
          },
        }
        console.debug('DEBUG [FREIGHT FORM] setting formData.address after CEP lookup', next.address)
        return next
      })
    } catch (error) {
      console.error('Erro ao buscar o CEP:', error)
      setFeedback({
        isOpen: true,
        message: 'CEP inexistente',
        statusOk: false,
      })
    }
  }

  useEffect(() => {
    setAddressPutBody({
      id: freight?.Address?.id,
      cep: freight?.Address?.cep || '',
      street: freight?.Address?.street || '',
      number: freight?.Address?.number || '',
      complement: freight?.Address?.complement || '',
      neighborhood: {
        name: freight?.Address?.Neighborhood?.name || '',
        id: freight?.Address?.Neighborhood?.id || 0,
      },
      city: {
        name: freight?.Address?.Neighborhood?.City?.name || '',
        id: freight?.Address?.Neighborhood?.City?.id || 0,
      },
      state: {
        name: freight?.Address?.Neighborhood?.City?.State?.name || '',
        id: freight?.Address?.Neighborhood?.City?.State?.id || 0,
      },
    })
  }, [freight])

  const handleClient = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newClient = e.target.value
    if (newClient === selectedClient) {
      setSelectedClient(null)
    } else {
      setSelectedClient(newClient)
    }
  }

  const handleType = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newType = e.target.value
    setSelectedType(newType)
    setFormData((prevData) => ({
      ...prevData,
      type: newType,
    }))
  }

  const applyCompanyAddressToFreight = (addr: CompanyAddressShape) => {
    const cepDigits = String(addr.cep || '').replace(/\D/g, '')
    const cepDisplay = formatCepDisplay(addr.cep)
    const street = addr.street || ''
    const neighborhoodName = addr.neighborhood?.name || ''
    const cityName = addr.city?.name || ''
    const stateName = addr.state?.name || ''

    setAutoAddress({
      street: !!street,
      neighborhood: !!neighborhoodName,
      city: !!cityName,
      state: !!stateName,
    })

    const addressBody = {
      cep: cepDigits,
      street,
      number: addr.number || '',
      complement: addr.complement || '',
      neighborhood: {
        name: neighborhoodName,
        id: addr.neighborhood?.id || 0,
      },
      city: {
        name: cityName,
        id: addr.city?.id || 0,
      },
      state: {
        name: stateName,
        id: addr.state?.id || 0,
      },
    }

    if (freight) {
      setAddressPutBody((prev) => ({
        ...prev,
        ...addressBody,
      }))
    } else {
      setAddressPostBody((prev) => ({
        ...prev,
        ...addressBody,
      }))
    }

    setFormData((prev) => ({
      ...prev,
      address: {
        cep: cepDisplay,
        street,
        number: addr.number || '',
        complement: addr.complement || '',
        neighborhood: {
          name: neighborhoodName,
          city: {
            name: cityName,
            state: {
              name: stateName,
            },
          },
        },
      },
    }))

    if (cepDigits.length === 8) {
      lastSearchedCep.current = cepDigits
    }
  }

  const handleCompanyAddressSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const key = e.target.value
    setSelectedCompanyAddressKey(key)

    const option = companyAddressOptions.find((item) => item.key === key)
    if (option) {
      applyCompanyAddressToFreight(option.address)
    }
  }

  useEffect(() => {
    setSelectedCompanyAddressKey('')

    if (!company.id || selectedType === 'Sem endereço') {
      setCompanyAddressOptions([])
      return
    }

    let cancelled = false

    const loadCompanyAddresses = async () => {
      try {
        const response = await ApiService.companies.findById(company.id)
        if (cancelled) return
        setCompanyAddressOptions(buildCompanyAddressOptions(response.data))
      } catch (error) {
        if (!cancelled) {
          console.error('Erro ao buscar endereços da empresa:', error)
          setCompanyAddressOptions([])
        }
      }
    }

    loadCompanyAddresses()

    return () => {
      cancelled = true
    }
  }, [company.id, selectedType])

  useEffect(() => {
    getCompanies()
  }, [])

  useEffect(() => {
    setSelectedType(freight?.type || 'Entrega')
  }, [freight])

  return (
    <ModalTest>
      <Container>
        <GridContainer>
          <HeaderDiv style={{ gridArea: `titleNew` }}>
            <HeaderText>{!freight ? 'Novo frete' : 'Editar frete'}</HeaderText>
            <CloseDiv onClick={() => close()}>
              <CloseImg src={cross} alt='Close tab' />
            </CloseDiv>
          </HeaderDiv>

          <InputDiv className='client' style={{ gridArea: `client` }}>
            <SelectContainer>
              <CenterItensContainer>
                <InputLabel>Empresa demandante</InputLabel>
                <ConformityStatus isvalue={!company.id}>
                  {company.id ? (
                    <>
                      <Check size={20} />{' '}
                    </>
                  ) : (
                    <>
                      <Info size={18} />{' '}
                    </>
                  )}
                </ConformityStatus>
              </CenterItensContainer>

              <SelectCustomerInFreight
                client={company}
                setClient={setCompany}
              />
            </SelectContainer>
          </InputDiv>

          <InputDiv style={{ gridArea: `type` }}>
            <SelectContainer>
              <CenterItensContainer>
                {' '}
                <InputLabel>Tipo</InputLabel>
              </CenterItensContainer>
              <SelectData
                value={selectedType || freight?.type || ''}
                onChange={handleType}
              >
                <StyledOption value={freight?.type || ''} disabled>
                  {freight?.type || 'Selecione...'}
                </StyledOption>
                {types.map((type) => (
                  <StyledOption value={type} key={type}>
                    {type}
                  </StyledOption>
                ))}
              </SelectData>
            </SelectContainer>
          </InputDiv>

          <InputDiv style={{ gridArea: `orderNumber` }}>
            <CenterItensContainer>
              <InputLabel>Numero de venda</InputLabel>
            </CenterItensContainer>
            <Input
              onChange={(e) => setOrderNumber(e.target.value)}
              value={orderNumber || ''}
              placeholder='Digite aqui'
            />
          </InputDiv>

          <InputDiv style={{ gridArea: `date` }}>
            <CenterItensContainer>
              <InputLabel>Data limite</InputLabel>
              <ConformityStatus isvalue={formData.deadLine.length < 10}>
                {!(formData.deadLine.length < 10) ? (
                  <>
                    <Check size={20} />{' '}
                  </>
                ) : (
                  <>
                    <Info size={18} />{' '}
                  </>
                )}
              </ConformityStatus>
            </CenterItensContainer>
            <StyledDate
              type='date'
              onChange={(e) => handleDateChange(e, 'deadLine')}
              value={formatToDateInput(formData.deadLine)}
              max='9999-12-31'
            />
          </InputDiv>

          <InputDiv style={{ gridArea: `readyToShip` }}>
            <CenterItensContainer>
              <InputLabel>Liberado pra expedir</InputLabel>
              <ConformityStatus isvalue={formData.readyToShip.length < 10}>
                {!(formData.readyToShip.length < 10) ? (
                  <>
                    <Check size={20} />{' '}
                  </>
                ) : (
                  <>
                    <Info size={18} />{' '}
                  </>
                )}
              </ConformityStatus>
            </CenterItensContainer>
            <StyledDate
              type='date'

              onChange={(e) => handleDateChange(e, 'readyToShip')}
              value={formatToDateInput(formData.readyToShip)}
              max='9999-12-31'
            />
          </InputDiv>

          {selectedType !== 'Sem endereço' && (
            <>
              <LineDiv></LineDiv>
              <HeaderDiv style={{ gridArea: `titleAdd` }}>
                <HeaderText>
                  Endereço{' '}
                  {(selectedType?.includes('Entrega') && 'de entrega') ||
                    'de coleta'}
                </HeaderText>
              </HeaderDiv>

              <InputDiv className='companyAddress' style={{ gridArea: 'companyAddress', gridColumn: '1 / -1' }}>
                <InputLabel>Endereço da empresa</InputLabel>
                <CompanyAddressSelect
                  value={selectedCompanyAddressKey}
                  onChange={handleCompanyAddressSelect}
                  disabled={!company.id || companyAddressOptions.length === 0}
                >
                  <StyledOption value=''>
                    {!company.id
                      ? 'Selecione uma empresa primeiro'
                      : companyAddressOptions.length === 0
                        ? 'Nenhum endereço cadastrado'
                        : 'Selecione um endereço...'}
                  </StyledOption>
                  {companyAddressOptions.map((option) => (
                    <StyledOption key={option.key} value={option.key}>
                      {option.label}
                    </StyledOption>
                  ))}
                </CompanyAddressSelect>
              </InputDiv>

              <InputDiv style={{ gridArea: `cep` }}>
                <InputLabel>CEP</InputLabel>
                <Input
                  onChange={(e) => {
                    handleDataChange('address.cep', e.target.value)
                    getCep(e.target.value)
                  }}
                  maxLength={9}
                  value={formData.address.cep || ''}
                  placeholder='Digite aqui'
                />
              </InputDiv>

              <InputDiv style={{ gridArea: `street` }}>
                <InputLabel>Logradouro</InputLabel>
                <Input
                  placeholder='Digite aqui'
                  value={formData.address.street ?? ''}
                  readOnly={autoAddress.street}
                  onChange={(e) =>
                    handleDataChange('address.street', e.target.value)
                  }
                />
              </InputDiv>

              <InputDiv style={{ gridArea: `neighborhood` }}>
                <InputLabel>Bairro</InputLabel>
                <Input
                  placeholder='Digite aqui'
                  value={formData.address.neighborhood.name ?? ''}
                  readOnly={autoAddress.neighborhood}
                  onChange={(e) => {
                    console.log('DEBUG [FREIGHT FORM] neighborhood input change', {
                      value: e.target.value,
                      autoAddress: autoAddress.neighborhood,
                    })
                    handleDataChange('address.neighborhood.name', e.target.value)
                  }}
                />
              </InputDiv>

              <InputDiv style={{ gridArea: `number` }}>
                <InputLabel>Número</InputLabel>
                <Input
                  onChange={(e) =>
                    handleDataChange('address.number', e.target.value)
                  }
                  value={formData.address.number || ''}
                  placeholder='Digite aqui'
                />
              </InputDiv>

              <InputDiv style={{ gridArea: `state` }}>
                <InputLabel>Estado</InputLabel>
                <Input
                  placeholder='Digite aqui'
                  value={formData.address.neighborhood.city.state.name ?? ''}
                  readOnly={autoAddress.state}
                  onChange={(e) =>
                    handleDataChange('address.neighborhood.city.state.name', e.target.value)
                  }
                />
              </InputDiv>

              <InputDiv style={{ gridArea: `city` }}>
                <InputLabel>Cidade</InputLabel>
                <Input
                  placeholder='Digite aqui'
                  value={formData.address.neighborhood.city.name ?? ''}
                  readOnly={autoAddress.city}
                  onChange={(e) =>
                    handleDataChange('address.neighborhood.city.name', e.target.value)
                  }
                />
              </InputDiv>

              <InputDiv style={{ gridArea: `complement` }}>
                <InputLabel>Complemento</InputLabel>
                <Input
                  onChange={(e) =>
                    handleDataChange('address.complement', e.target.value)
                  }
                  value={formData.address.complement || ''}
                  placeholder='Digite aqui'
                />
              </InputDiv>
            </>
          )}

          <LineDiv style={{ gridArea: `line2` }}></LineDiv>
          <HeaderDiv style={{ gridArea: `titleLoad` }}>
            <HeaderText>Carga</HeaderText>
          </HeaderDiv>

          <InputDiv style={{ gridArea: `height` }}>
            <InputLabel>Altura</InputLabel>
            <Input
              type='number'
              min={0}
              onChange={(e) =>
                handleDataChange(
                  'load.height',
                  e.target.value.replace(',', '.'),
                )
              }
              value={formData.load.height}
              placeholder='Digite aqui'
            />
          </InputDiv>

          <InputDiv style={{ gridArea: `width` }}>
            <InputLabel>Largura</InputLabel>
            <Input
              type='number'
              min={0}
              onChange={(e) =>
                handleDataChange('load.width', e.target.value.replace(',', '.'))
              }
              value={formData.load.width}
              placeholder='Digite aqui'
            />
          </InputDiv>

          <InputDiv style={{ gridArea: `length` }}>
            <InputLabel>Comprimento</InputLabel>
            <Input
              type='number'
              min={0}
              onChange={(e) =>
                handleDataChange(
                  'load.length',
                  e.target.value.replace(',', '.'),
                )
              }
              value={formData.load.length}
              placeholder='Digite aqui'
            />
          </InputDiv>

          <InputDiv style={{ gridArea: `cubage` }}>
            <InputLabel>Cubagem</InputLabel>
            <Input
              type='number'
              min={0}
              onChange={(e) =>
                handleDataChange(
                  'load.cubage',
                  e.target.value.replace(',', '.'),
                )
              }
              value={formData.load.cubage}
              placeholder='Digite aqui'
            />
          </InputDiv>

          <InputDiv style={{ gridArea: `weight` }}>
            <InputLabel>{'Peso (Kg)'}</InputLabel>
            <Input
              type='number'
              min={0}
              onChange={(e) =>
                handleDataChange(
                  'load.weight',
                  e.target.value.replace(',', '.'),
                )
              }
              value={formData.load.weight}
              placeholder='Digite aqui'
            />
          </InputDiv>

          <InputDiv style={{ gridArea: `detail` }}>
            <InputLabel>Detalhe</InputLabel>
            <Input
              onChange={(e) => handleDataChange('load.detail', e.target.value)}
              value={formData.load.detail || ''}
              placeholder='Digite aqui'
            />
          </InputDiv>

          <LineDiv style={{ gridArea: `line3` }}></LineDiv>
          <InputDiv style={{ gridArea: `observation` }}>
            <InputLabel>Observação</InputLabel>
            <Input
              onChange={(e) => setObservation(e.target.value)}
              value={observation || ''}
              placeholder='Digite aqui'
            />
          </InputDiv>
        </GridContainer>

        <OptionsDiv>
          <ButtonCreate className='reverse' onClick={() => close()}>
            Cancelar
          </ButtonCreate>

          {duplicateBlocker ? (
            <ButtonCreate className='disable'>Aguarde..</ButtonCreate>
          ) : (
            <ButtonCreate
              onClick={async () => {
                if (!freight) {
                  await postFreight()
                } else {
                  await putFreight()
                }
              }}
            >
              <img src={!freight ? plus : save}></img>
              {!freight ? 'Salvar frete' : 'Salvar alterações'}
            </ButtonCreate>
          )}
        </OptionsDiv>
      </Container>
    </ModalTest>
  )
}

export default FreightForm
